module.exports = __webpack_public_path__ + "img/p8.560fa320.png";